<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<h2 mat-dialog-title class="mat-h2">
  Add Project
  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (isBrowserWarning) {
    <p class="browser-warning">
      Please use either Chrome or Microsoft Edge browsers to fill and submit the form for your sample testing.
    </p>
  }
  <form [formGroup]="materialTypeForm" #ngForm="ngForm">
    <p>Please choose the type of samples you wish to submit for testing.</p>
    <mat-radio-group color="primary" aria-label="Select an option" formControlName="materialType" required [disabled]="autoFillClicked">
      <ul class="list-style-type-none">
        <li>
          <mat-radio-button value="native-soil">Native Soil or Backfill</mat-radio-button>
        </li>
        <li>
          <mat-radio-button value="precast">Pre Cast - Concrete, FTB, Grout/Slurry</mat-radio-button>
        </li>
      </ul>
    </mat-radio-group>
    @if (ngForm?.submitted && materialTypeForm?.get('materialType')?.invalid) {
      <mat-error>
        Please Select Material Type.
      </mat-error>
    }
    @if (showFileUpload) {
      <div id="fileupload">
        <div class="browser-container" (change)="onFileSelected($event)" #fileInput>
          <input class="cursor-pointer" title="" type="file" #fileDropRef id="fileDropRef" single [disabled]="filePickDisabled" accept=".pdf"/>
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <p>Drag and drop submission form</p>
          <p>or</p>
          <button mat-raised-button (click)="fileInput.click()" [disabled]="filePickDisabled">Browse files</button>
          <p class="file-size">Maximum File Size is 10 MB and Permissible File Type is PDF</p>
        </div>
        <!-- file upload progress-->
        <div class="files-list">
          @for (file of uploadedFiles; track file; let i = $index) {
            <div class="single-file">
              <div class="file-icon" style="width: 50px">
                <mat-icon> insert_drive_file</mat-icon>
              </div>
              <div class="info">
                <h4 class="name">
                  {{ file.file.name }}
                </h4>
                <p class="size">
                  {{ file.file.size | fileSize }}
                </p>
                <div class="progress-cont">
                  @if (!file.completed && file.progress < 100) {
                    <div>
                      <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
                      <p>{{ file.progress.toFixed(0) }}%</p>
                    </div>
                  }
                </div>
              </div>
              <div class="delete" (click)="cancelUpload(file)">
                <mat-icon>close</mat-icon>
              </div>
            </div>
          }
        </div>
        @if (errorMessage) {
          <p class="error-message">{{ errorMessage }}</p>
        }
      </div>
    }
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
  <div class="btn-class">
    <button mat-raised-button (click)="closeDialog()">CANCEL</button>

    <div>
      @if (!showFileUpload) {
        <button mat-raised-button color="primary" [disabled]="materialTypeForm.invalid"  (click)="handleButtonClick()" type="button">
          AUTO FILL
        </button>
      }
      @if (apiInProgress) {
        <button mat-raised-button color="primary" (click)="handleButtonClick()" type="button">
          AUTO FILL
        </button>
      }
      @if (!showFileUpload) {
        <button
          mat-raised-button
          color="primary"
          [disabled]="materialTypeForm.invalid"
          type="submit"
          (click)="onClickSubmit()">
          MANUAL
        </button>
      }
    </div>
  </div>
</mat-dialog-actions>

